import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const erasmusSubjectApi = createApi({
  reducerPath: 'erasmusSubjectApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getErasmusSubjects: builder.query({
      query: () => {
        return {
          url: urls.erasmusSubjects,
        };
      },
    }),
    getErasmusSubject: builder.query({
      query: (id) => ({
        url: urls.erasmusSubjectDetail(id),
      }),
    }),
    saveErasmusSubject: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.erasmusSubjectDetail(req.id),
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: urls.erasmusSubjects,
            method: 'POST',
            data: req.body,
          };
        }
      },
    }),
    deleteErasmusSubject: builder.mutation({
      query(id) {
        return {
          url: urls.erasmusSubjectDetail(id),
          method: 'DELETE',
        };
      },
    }),
    saveErasmusSubjectUniversities: builder.mutation({
      query(req) {
        return {
          url: urls.createConsortiumsUniversities,
          method: 'POST',
          data: req,
        };
      },
    }),
  }),
});

export const {
  useGetErasmusSubjectsQuery,
  useGetErasmusSubjectQuery,
  useSaveErasmusSubjectMutation,
  useDeleteErasmusSubjectMutation,
  useSaveErasmusSubjectUniversitiesMutation,
} = erasmusSubjectApi;
